/// <reference path="../../web/scripts/types/angular-file-upload.d.ts" />
/// <reference path="../../web/scripts/apps/main.ts" />
declare var recaptchaResponse: string;
declare var APIURL: string;
declare interface Array<T> {
    /**
     * Get last element of Array
     * */
    lastElement(): T;
}

if (!Array.prototype.lastElement) {
    Array.prototype.lastElement = function () {
        if (!this.length)
            throw Error("Array is empty");
        return this[this.length - 1];
    }
}

interface JsonBooking extends IBookingData {
    mindate: moment.Moment,
    maxdate: moment.Moment,
    freezingHours?: number
}

interface PrebookingMultiple {
    booking: JsonBooking;
    products: BookingProduct[];
    code: string;
    pin: string;
}

interface CustomPrivacy {
    privacyIt: string;
    privacyEn: string;
    privacyLinkIt: string;
    privacyLinkEn: string;
    cookieIt: string;
    cookieEn: string;
    cookieLinkIt: string;
    cookieLinkEn: string;
}

interface IBookingData {
    email: string;
    selecteddate: string | null;
    selectedtime: number | string;
    selectedTruckType: string;
    carrier: string;
    refname: string;
    refnum: string;
    truckplate: string;
    trailerplate: string;
    sender: string;
    phonenumber: string;
    receiver: string;
    notes: string;
    privacySelectedValue: string;
    country: string;
    external: string;
}
interface IBookScope extends ng.IScope {
    mandAttachments: (group: number) => boolean;
    searchData: moment.Moment;
    formLink: string;
    formLabel: string;
    showLabel: (fieldName: string) => string;
    showTooltip: (fieldName: string) => string;
    showProductLabel: (fieldName: string) => string;
    isColumnVisible: (fieldName: string) => boolean;
    columnVisibilityError: boolean;
    isVisible: (field: string) => boolean;
    isNaN: (a: number) => boolean;
    prebooking: boolean;
    is_privacy_checked: () => boolean;
    customPrivacy: CustomPrivacy;
    getCustomPrivacy: () => void;
    is_prebooked: boolean;
    prebookedstatus: -1 | 0 | 1;
    tz: () => string;
    products: BookingProduct[];
    docks: CustomerPlant[];
    hub_id: number;
    data: IBookingData & {
        //aggiunti
        startdate?: moment.Moment;
    };
    allLapses: ILapseAvailable[];
    filteredLapses: ILapseAvailable[];
    type: string;
    startdate: moment.Moment;
    //posMarkers: PosMarkers[];
    sd: any;
    format: string;
    productGroupsValues: ProductGroupValue[];
    duration: number;
    plantId: number;
    loadUnload: any[];
    loadingLapses: boolean;
    truckTypes: ICodeNameOrder[];
    destinations: ICodeNameOrder[];
    tripTypes: ICodeNameOrder[];
    selectedTruckType: string;
    customerCode: string;
    plantCode: string;
    bookingCode: string;
    uploader1: FileUploader;
    uploader2: FileUploader;
    uploader3: FileUploader;
    mandStep: any;
    atleastOne: boolean;
    shipment: any;
    currentData: any;
    hours: number[];
    selectedDatetime: moment.Moment;
    emailRegex: RegExp;
    waitPrevious: boolean;
    waitNext: boolean;
    totQty: number;
    filePath: string;
    uploadSuccess: boolean;
    bookingFilePath: string;
    hubSR: any;
    confirmUpload: boolean;
    now: string | moment.Moment;
    todayWD: WorkingDay;
    selectedWD: WorkingDay;
    allowPdfDownload: boolean;
    canSave: boolean;
    sameDaySlot: boolean;
    maxlimit: number;
    privacyStatement: string;
    freezeBooking: number;
    firstValidResult: ILapseAvailable;
    minValidDate: moment.Moment;
    loadUnloadEnabled: boolean;
    origLoadUnload: any[];
    productsPreviewStrings: string[];
    mandatoryFieldsList: WfMandatoryField[];
    bookingFieldLabels: BookingFieldLabelsGet;
    docksLimit: number;
    emailValid: boolean;
    effDuration: number;
    accordionGroup: { existing: boolean, fromScratch: boolean, anchor: string, hideFromScratch: boolean };
    shipCode: string;
    unlockCode: string;
    errorMessage: string;
    isDisabledSelectFromExistingShipment: boolean;
    getBookingAvail: (validateFn: () => boolean) => void;
    recheckResults: (startdate: moment.Moment, direction: LM.Direction, isfirst?: boolean, filterCode?: string, nextDay?: boolean) => void;
    selectLapse: (lapse: any) => void;
    saveBooking: (loc?: CustomerPlant) => void;
    addProductRow: () => void;
    editProductRow: (product: any) => void;
    checkScreensize: () => boolean;
    downloadPdf: (bookingCode: string) => void;
    removeRow: (product: any) => void;
    upload: (group: number) => void;
    isInUploadingPhase1: (file: any) => boolean;
    isInUploadingPhase2: (file: any) => boolean;
    isInUploadingPhase3: (file: any) => boolean;
    deleteFile: (file: any, group: number) => void;
    validates2: () => boolean;
    validates3: () => boolean;
    validateTruckType: () => boolean;
    validateValue: (value: string) => boolean;
    fillFields: () => void;
    PrintElem: (elem: string) => void;
    PrintPDF: (bookingCode: string, linkId?: string) => void;
    getUploadedPdf: (pdfName: string) => void;
    checkConditions: () => void;
    sanitize: () => void;
    isMandatory: (field: string, value: string) => boolean;
    checkEmail: (email: string) => void;
    findShipments: (shipmentCode: string, unlockCode: string) => void;
    findMultipleShipments: (params: string) => void;
    bloppo: (h: moment.Moment) => boolean;
    navigation_wizard_enabled: () => boolean;
    fileUploadError1: string;
    fileUploadError2: string;
    fileUploadError3: string;
    init: () => void;
    emptyLapses: () => void;
    refreshSlots: (filterCode: string) => void;
    showLoading: boolean;
    InvitationOnly: boolean;
    linkId: string;
    isEditable: (field: string, value: string) => boolean;
    prebookings: Array<LM.Prebooking & IBookingData>;
    removePrebooking: (index: number) => void;
    confirmPrebooking: () => void;
    prebookingConfirmed: boolean;
    showAutocompleteBtn: boolean;
    changeDayCheckResult: (direction: LM.Direction) => void;
    newBookingError: boolean;
    attachments1Count: number;
    attachments2Count: number;
    attachments3Count: number;
    quantityWarning: (value: number, code: string) => void;
    triggerQuantity: (product?: BookingProduct) => void;
    getProductLimit: (productCode: string) => number;
    skip: any;
    firstTitle: string;
    secondTitle: string;
    whInternalContactPhone: string;
    whInternalContactEmail: string;
    cutMinMaxDates: boolean;
    passedMaxDate: boolean;
    passedMinDate: boolean;
    fileNotLoadedYet1: any[];
    fileNotLoadedYet2: any[];
    fileNotLoadedYet3: any[];
    maxDays: number;
    initialDateTime: moment.Moment;
}
namespace LM {

    export interface IGetD {
        productGroups: ICodeNameOrder[];
        trucks: ICodeNameOrder[];
        reasons: (ICodeName & { Red: boolean })[];
        destinations: ICodeNameOrder[];
        x: string;
        customerCode: string;
        tripTypes: ICodeNameOrder[];
        openingHour: string | null;
        closingHour: string | null;
        FreezeBooking: number;
        workflowEnabled: ActionType[];
        maxDocks: number | null;
        Tz: string;
        InvitationOnly: boolean;
    }

    export interface IGetWorkingTime {
        openingHour: string;
        closingHour: string;
        maxDocks: number | null;
    }

    export enum Direction {
        Forward = 'forward',
        Backward = 'backward'
    };

    export enum EmailStatus {
        WhiteList,
        Existing,
        BlackList
    };
    export interface Prebooking {
        shipCode: string;
        unlockCode: string;
        products: BookingProduct[];
        minDate: string | moment.Moment;
        maxDate: string | moment.Moment;
    }
    var nextDateDay: moment.Moment = null;
    export abstract class BookingBase<T extends IBookScope> {
        protected volume: angular.IHttpResponse<{ [key: string]: number; }>;
        protected now(): moment.Moment {
            return moment.tz(this.TZ);
        }
        protected min: moment.Moment = this.now();
        protected max: moment.Moment | null = null;
        protected delays: { StartDate: moment.Moment, EndDate: moment.Moment | null, BookingTollerance: number }[];
        protected actionWf: LM.ActionType;
        protected MAXDAYS: number = 90;
        protected Language: string;
        protected limitDay: moment.Moment | null = null;
        protected firstProposedSlot: moment.Moment | null = null;

        constructor(public $scope: T, public genericHelper: LM.GenericHelperService, $uibModal: any, WizardHandler: any, FileUploader: FileUploader, protected $http: ng.IHttpService) {
            this.Language = LangService.getLanguage();
            $scope.tz = () => this.TZ;
            $scope.columnVisibilityError = false;
            $scope.docks = [];
            $scope.skip = false;
            $scope.firstTitle = '2';
            $scope.secondTitle = '3';
            $scope.whInternalContactPhone = "";
            $scope.whInternalContactEmail = "";
            $scope.sameDaySlot = true;
            $scope.maxlimit = NaN;
            //$scope.posMarkers = [];
            $scope.productGroupsValues = [];
            $scope.products = [];
            $scope.filteredLapses = [];
            $scope.truckTypes = [];
            $scope.destinations = [];
            $scope.tripTypes = [];
            $scope.hours = [];
            $scope.attachments1Count = 0;
            $scope.attachments2Count = 0;
            $scope.attachments3Count = 0;
            $scope.productsPreviewStrings = [];
            $scope.data = {
                selectedTruckType: '',
                selecteddate: null,
                selectedtime: 0,
                email: '',
                carrier: '',
                refname: '',
                external: '',
                refnum: '',
                truckplate: '',
                trailerplate: '',
                phonenumber: '',
                notes: '',
                sender: '',
                receiver: '',
                privacySelectedValue: '',
                country: 'it'
            };
            $scope.totQty = 0;
            $scope.bookingFilePath = '';
            $scope.loadUnload = [{ name: 'Load', img: '../../Content/Icons/load.png' }, { name: 'Unload', img: '../../Content/Icons/unload.png' }];
            $scope.now = this.now();//.format('YYYY-MM-DD');
            $scope.fileNotLoadedYet1 = [];
            $scope.fileNotLoadedYet2 = [];
            $scope.fileNotLoadedYet3 = [];
            for (let i: number = 0; i <= 23; i++)
                $scope.hours.push(i);
            $scope.isNaN = (a: number) => !angular.isNumber(a) || isNaN(a);
            $scope.filePath = (Math.random() * 1e4).toString();
            $scope.uploader1 = new FileUploader();
            $scope.uploader2 = new FileUploader();
            $scope.uploader3 = new FileUploader();
            $scope.confirmUpload = false;
            $scope.selectedWD = {
                Opening: this.now(),
                Closing: this.now()
            };
            $scope.todayWD = {
                Opening: this.now(),
                Closing: this.now()
            };
            $scope.accordionGroup = {
                existing: false,
                fromScratch: true,
                anchor: '',
                hideFromScratch: false
            };
            $scope.prebookings = [];
            $scope.prebookingConfirmed = false;
            $scope.showAutocompleteBtn = true;
            $scope.newBookingError = false;
            //$scope.addPrebooking = () => $scope.prebookings.push({ shipCode: '', unlockCode: '' });

            $scope.removePrebooking = (index: number) =>
                $scope.prebookings.splice(index, 1);

            $scope.init = function () {
                $scope.columnVisibilityError = false;
            }

            $scope.bloppo = (h: moment.Moment): boolean => {
                if (!moment.isMoment(this.max) || !this.max.isValid())
                    return true;
                if (!moment.isMoment(h))
                    return false;
                //if (moment.isMoment(this.min)) {
                if (this.min.isSameOrAfter(h))
                    return false;
                if (moment.isMoment(this.max))
                    return this.max.isSameOrAfter(h);
                //}
                return true;
            };

            $scope.getBookingAvail = (validateFn: () => boolean, loc?: any, filterCode: string = '') => {
                if (validateFn()) {
                    const plant: CustomerPlant = loc || this.getCustomerPlant();
                    $scope.plantId = plant.Id;
                    $scope.loadingLapses = true;
                    $scope.allLapses = [];
                    $scope.showLoading = true;

                    this.actionWf = $scope.products.every(x => x.Type == 'Load') ? LM.ActionType.Load : $scope.products.every(x => x.Type == 'Unload') ? LM.ActionType.Unload : LM.ActionType.LoadUnload;
                    BrainyHelper.calculateDuration(genericHelper.$http, $scope.customerCode, $scope.plantCode, $scope.data.selectedTruckType, $scope.products.map(p => (<BrainyHelper.Package>{
                        PackageType: p.Code,
                        Quantity: p.Value,
                        DestinationCountry: p.Destination,
                        DeliveryMethod: p.TripType,
                        Action: p.Type == 'Load' ? LM.ActionType.Load : p.Type == 'Unload' ? LM.ActionType.Unload : p.Type == 'LoadUnload' ? LM.ActionType.LoadUnload : LM.ActionType.None
                    }))).then(res => {
                        $scope.duration = res.Average; //Expected;
                        $scope.effDuration = res.Expected;
                        $scope.searchData = nextDateDay = moment.tz($scope.data.selecteddate, 'YYYY/MM/DD', this.TZ).startOf('d').add($scope.data.selectedtime, 'h');
                        //$scope.recheckResults($scope.searchData.add(1, 'd'), Direction.Forward);
                        recheckRes($scope.searchData, Direction.Forward, true, filterCode).then(_ => {
                            $scope.showLoading = false;
                            if (WizardHandler.wizard().currentStep().wzTitle == $scope.firstTitle) {
                                $http.post<boolean>('/Booking/Book/CanSkipSlotSelection', {
                                    PlantId: $scope.plantId,
                                    ProductInfos: $scope.products,
                                    TruckType: $scope.data.selectedTruckType
                                }).then(function (response) {
                                    $scope.skip = response.data;
                                    WizardHandler.wizard().next();
                                });
                            }
                            if (WizardHandler.wizard().currentStep().wzTitle == $scope.secondTitle && $scope.skip == 'True') {
                                var now = moment();
                                if ($scope.filteredLapses[0].From <= now && $scope.filteredLapses.length > 1) {
                                    $scope.filteredLapses[1].Selected = true;
                                    $scope.selectLapse($scope.filteredLapses[1]);
                                } else {
                                    $scope.filteredLapses[0].Selected = true;
                                    $scope.selectLapse($scope.filteredLapses[0]);
                                }
                                $scope.canSave = true;
                                $scope.saveBooking(loc);
                            } else {
                                if (WizardHandler.wizard().currentStep().wzTitle != $scope.firstTitle) {
                                    WizardHandler.wizard().next();
                                }
                            }
                        }, err => {
                            console.log(err);
                            $scope.showLoading = false;
                            $uibModal.open({
                                templateUrl: '/Templates/SlotUnavailable.html',
                                windowClass: 'slotUnavail',
                                scope: angular.extend($scope, {
                                    notExpiring: this.notExpiringRules($scope.currentData != null ? $scope.currentData.x : null),
                                    whInternalContactEmail: $scope.whInternalContactEmail,
                                    whInternalContactPhone: $scope.whInternalContactPhone,
                                    date: moment.tz($scope.data.selecteddate, 'YYYY/MM/DD', this.TZ).add(30, 'd').toDate()
                                })
                            });
                        });
                    });
                    this.saveStep(2);
                }

            };

            $scope.changeDayCheckResult = (direction: Direction) =>
                $scope.recheckResults(nextDateDay, direction, false, '', true);

            /**
             * Funzione per ottenere gli slot temporali
             * 
             * @param startdate Data di partenza per calcolo degli slot
             * @param direction Direzione per cercare avanti o indietro nel tempo
             * @param isFirstRun Flag per definire se è primo giro di richiesta slot
             * @param filterCode Stringa per filtrare un codice dalla lista delle prenotazioni esistenti
             * @param nextDay Flag per saltare al giorno successivo/precedente
             */
            $scope.recheckResults = (startdate: moment.Moment, direction: Direction, isFirstRun: boolean = false, filterCode: string = '', nextDay: boolean = false) => {
                recheckRes(startdate, direction, isFirstRun, filterCode, nextDay)
                    .then(_ => console.log("Completed"),
                        err => {
                            $scope.errorMessage = "Non c'è disponibilità";
                            $scope.filteredLapses = [];
                            $scope.loadingLapses = false;
                            $scope.$apply();
                            console.log(err);
                        });
            }

            /**
             * Funzione per controllare se abbiamo superato il limite di 30 giorni
             * @param startdate data richiesta
             */
            const blockSearch = (startdate: moment.Moment) => {
                if ($scope.allLapses.length == 0 && startdate.isAfter(moment.tz($scope.data.selecteddate, 'YYYY/MM/DD', this.TZ).add('d', 30))) {
                    throw new Error("Blocco ricerca");
                }
            }

            function manageRemainingDays(direction: LM.Direction, actualDate: moment.Moment) {
                if ($scope.searchData != actualDate)
                    if (direction == LM.Direction.Forward) {
                        if (remainingDays >= 0)
                            remainingDays--;
                    }
                    else
                        remainingDays++;
            }

            let remainingDays = 0;
            const recheckRes = async (startdate: moment.Moment, direction: Direction, isFirstRun: boolean = false, filterCode: string = '', nextDay: boolean = false) => {
                $scope.passedMaxDate = false;
                $scope.passedMinDate = false;
                let maxDate = this.max ?? this.limitDay;
                if (isFirstRun) {
                    remainingDays = 0;
                    $scope.maxDays = 0;
                }
                //Se si arriva oltre 30 giorni nella ricerca di slot disponibili esci
                blockSearch(startdate);

                if (direction == LM.Direction.Forward) {
                    const filtered: ILapseAvailable[] = $scope.allLapses.filter(l => l.From.isAfter(startdate));
                    //Esistono già risultati disponibili, non siamo al primo giro e non abbiamo cambiato giorno di consultazione
                    if (filtered.length > 0 && !isFirstRun && !nextDay) {
                        $scope.filteredLapses = filtered.slice(0, MAXRESULTS);
                        //Check per verificare se abbiamo superato la data max
                        if ($scope.cutMinMaxDates && maxDate && maxDate.isValid()) {
                            $scope.filteredLapses = $scope.filteredLapses.filter(x => x.From < maxDate);
                            const nextNonVisibleSlot = $scope.allLapses.filter(x => x.From > $scope.filteredLapses[$scope.filteredLapses.length - 1]?.From)[0];
                            //let nextNonVisibleSlot = f.length > 0 ? f[0] : null;
                            $scope.passedMaxDate = nextNonVisibleSlot && nextNonVisibleSlot.From.isValid() && nextNonVisibleSlot.From >= maxDate;
                        }
                    } else {
                        //Flag per evitare troppe chiamate
                        $scope.waitNext = true;

                        //Se siamo arrivati all'ultimo slot disponibile si passa al giorno successivo oppure se si avanza di giorno
                        if (($scope.allLapses.length > 0 && $scope.filteredLapses.length > 0 &&
                            $scope.allLapses.lastElement().From == $scope.filteredLapses.lastElement().From)
                            || nextDay) {
                            startdate.add(1, 'd').startOf('day');
                        }

                        $scope.loadingLapses = true;
                        //Vengono richiesti tutti i dati necessari (aperture, limite baie, prenotazioni esistenti, etc)
                        const res = await genericHelper.$http.post<any>('/Booking/Book/GetData', { Date: startdate, PlantId: $scope.plantId, direction: direction });
                        //Se non viene trovato niente, si prova ad andare sul giorno successivo
                        if (res.data == -1) {
                            startdate.add(1, 'd');
                            await recheckRes(startdate, Direction.Forward);
                        }
                        else {
                            $scope.currentData = res.data;
                            //const comboGroupRevamp: ComboGroupRevamp[] = $scope.currentData.cg.map((c: ComboGroup) => this.omit<ComboGroup, ComboGroupRevamp>(c, 'TruckTypeCode', 'From', 'To', 'Availability', 'Volume', 'LimitType'));
                            $scope.whInternalContactPhone = res.data.WarehouseInternalContactPhone;
                            $scope.whInternalContactEmail = res.data.WarehouseInternalContactEmail;
                            $scope.cutMinMaxDates = res.data.CutMinMaxDates;

                            if (!isFirstRun)
                                startdate = moment.tz($scope.currentData.OpeningTime, this.TZ).startOf('d');
                            $scope.docksLimit = res.data.MaxDocks;

                            //Rende libero lo slot della prenotazione da modificare
                            if (filterCode)
                                $scope.currentData.rows = $scope.currentData.rows.map((a: any) => ({
                                    ...a,
                                    Ships: a.Ships.filter((b: any) => b.Code != filterCode)
                                }));

                            //Le date di inizio, fine e pianificazione vengono castate a stringa, prendendo solo le prenotazioni future rispetto alla data di partenza
                            for (const d of $scope.currentData.rows) {
                                d.Ships = d.Ships.filter((s: any) => {
                                    if (s2m(s.RePlanned) >= startdate.clone().startOf('d')) {
                                        s.ExpStartLoad = s2m(s.ExpStartLoad).utc().format();
                                        s.ExpEndLoad = s2m(s.ExpEndLoad).utc().format();
                                        // Aggiunto .utc(), vedere se cambia nel calcolo degli slot 
                                        s.RePlanned = s2m(s.RePlanned).utc().format();
                                        // Reset volume per successivo ricalcolo
                                        s.Volume = 0;
                                        return true;
                                    }
                                    return false;
                                });
                            }

                            if (!$scope.maxDays) {
                                //Ricaviamo limite di massimi giorni da cercare
                                const slotDayLimits = U.filterSlotDayLimits(res.data.lims, $scope.products, $scope.data.selectedTruckType);
                                if (isFirstRun) {
                                    if (slotDayLimits.length) {
                                        $scope.maxDays = remainingDays = Math.min(...slotDayLimits.map(x => x.Days));
                                        manageRemainingDays(direction, startdate);
                                    }
                                }
                            } else {
                                manageRemainingDays(direction, startdate);
                            }

                            //Recuperiamo tutte le handling unit presenti fra le prenotazioni della giornata, nel caso sia presente comboGroup con ProductCode == null (*)
                            const cgWithAnyProd = (<ComboGroup[]>$scope.currentData.cg).some(x => x.ProductCode == null);
                            let allShipsProdTypes = [];
                            if (cgWithAnyProd)
                                allShipsProdTypes = Array.from(new Set((<any[]>$scope.currentData.rows).flatMap((x: any) => (<any[]>x.Ships).flatMap((y: any) => (<any[]>y.Items).flatMap((z: any) => z.Product_Code)))));
                            //Ricaviamo tutti i codici delle handling unit, sia products che combogroup
                            const productList = new Set(
                                Array.from(
                                    (<ComboGroup[]>$scope.currentData.cg)
                                        .map(x => x.ProductCode))
                                    .concat($scope.products.map(p => p.Code))
                                    .concat(allShipsProdTypes)
                                    .filter(x => x));
                            //Chiamata per calcolare volume
                            if (!this.volume || !this.volume.data)
                                this.volume = await $http.post<{ [key: string]: number }>('/Booking/Book/CalculateVolume', {
                                    products:
                                        Array.from(productList)
                                            .map(x => ({ productCode: x, quantity: 0 })),
                                    plantId: $scope.plantId
                                });
                            let avail = U.filterComboGroups((<ComboGroup[]>$scope.currentData.cg), $scope.products, $scope.data.selectedTruckType, this.volume.data);
                            if (avail) {
                                avail = avail.map(x => ({
                                    ...x,
                                    From: TargetToLocal(moment(x.From), this.TZ),
                                    To: TargetToLocal(moment(x.To), this.TZ)
                                }));
                            }

                            //Chiamata a funzione di Revamp per calcolo slot temporali
                            let lapsesFound = FindTimeLapses(<IDataFormat>{
                                rows: $scope.currentData.rows,
                                date: moment.invalid(),
                                OpeningTime: moment.tz($scope.currentData.OpeningTime, this.TZ),
                                ClosingTime: moment.tz($scope.currentData.ClosingTime, this.TZ),
                                dockGroups: $scope.currentData.dockGroups,
                                comboGroups: avail,
                                expectedVolume: this.volume.data
                            },
                                $scope.effDuration,
                                [],
                                // se sono in edit non considero idle time fra spedizioni
                                filterCode ? 0 : $scope.currentData.MininumDelay,
                                $scope.duration,
                                $scope.docksLimit);
                            //Se non sono disponibili slot riprova sulla giornata successiva
                            if (typeof lapsesFound === 'number') {
                                startdate.add(1, 'd');
                                await recheckRes(startdate, Direction.Forward, false);
                            } else {
                                //Slot vengono filtrati in base a regole di esclusione
                                $scope.allLapses = lapsesFound
                                    .filter(l => U.BondGate(
                                        l,
                                        $scope.products,
                                        $scope.data.selectedTruckType,
                                        startdate,
                                        JSON.parse($scope.currentData.x))
                                    );
                                //Vengono eliminati slot con stesso orario ma su baie diverse (viene mostrato solo lo slot con priorità maggiore)
                                $scope.allLapses = $scope.allLapses.reduce((cum: ILapseAvailable[], next: ILapseAvailable) => {
                                    if (!cum.some(c => c.From.isSame(next.From, 'minute')))
                                        cum.push(next);
                                    return cum;
                                }, []);
                                //Se si arriva oltre 30 giorni nella ricerca di slot disponibili esci
                                blockSearch(startdate);
                                //if ($scope.allLapses.length == 0 && startdate.isAfter(moment.tz($scope.data.selecteddate, 'YYYY/MM/DD', this.TZ).add('d', 30))) {
                                //    throw new Error("Blocco ricerca");
                                //}
                                //Se non sono disponibili slot riprova sulla giornata successiva
                                if ($scope.allLapses.length == 0) {
                                    startdate.add(1, 'd');
                                    await recheckRes(startdate, Direction.Forward);
                                }
                                //Se sono disponibili slot
                                else {
                                    $scope.errorMessage = '';
                                    $scope.productGroupsValues = $scope.currentData.productGroups.map((pg: any) => ({ Code: pg.Code.trim(), Name: pg.Name.trim(), Value: 0, Limit: pg.Limit }));
                                    if (isFirstRun && $scope.minValidDate != undefined)
                                        $scope.filteredLapses = $scope.allLapses.filter(l => l.From.isSameOrAfter($scope.minValidDate));
                                    else
                                        $scope.filteredLapses = $scope.allLapses.filter(l => l.From.isSameOrAfter(moment(startdate)));
                                    //    $scope.filteredLapses = $scope.allLapses.filter(l => l.From.isSameOrAfter(moment($scope.data.selecteddate).startOf('d').add($scope.data.selectedtime, 'h')));
                                    //Se non sono disponibili slot riprova sulla giornata successiva
                                    if ($scope.filteredLapses.length == 0) {
                                        startdate.add(1, 'd');
                                        await recheckRes(startdate, Direction.Forward);
                                    }
                                    else {
                                        if (isFirstRun) {
                                            //Serve??
                                            //$scope.firstValidResult = $scope.filteredLapses[0];

                                            if (this.min?.isValid()) {
                                                $scope.passedMinDate = $scope.filteredLapses.some(x => x.From < this.min);
                                                $scope.filteredLapses = $scope.filteredLapses.filter(x => x.From > this.min);
                                            }

                                            if ($scope.cutMinMaxDates && maxDate?.isValid()) {
                                                $scope.passedMaxDate = $scope.filteredLapses.some(x => x.From > maxDate);
                                                $scope.filteredLapses = $scope.filteredLapses.filter(x => x.From < maxDate);
                                            }

                                            $scope.filteredLapses = $scope.filteredLapses.filter(l => l.From.isSameOrAfter(startdate)).slice(0, MAXRESULTS);
                                            if ($scope.filteredLapses.length == 0) {
                                                if ($scope.passedMaxDate)
                                                    throw new Error("Blocco ricerca");
                                                //Se non troviamo risultati svuotiamo tutti gli slot e andiamo a domani
                                                $scope.allLapses = [];
                                                startdate.clone().add(1, 'd');
                                                await recheckRes(startdate, Direction.Forward);
                                            }
                                        }
                                        else {

                                            $scope.filteredLapses = $scope.filteredLapses.slice(0, MAXRESULTS);

                                            nextDateDay = $scope.filteredLapses[0].From.clone().startOf('d');

                                            if (($scope.cutMinMaxDates && maxDate?.isValid()) || remainingDays < 0) {
                                                if (maxDate?.isValid() && $scope.filteredLapses[0].From > maxDate || remainingDays < 0) {
                                                    $scope.filteredLapses[0].From.clone().subtract(1, 'd');
                                                    await recheckRes($scope.filteredLapses[0].From, Direction.Backward);
                                                }
                                            }
                                        }
                                    }
                                    $scope.waitPrevious = false;
                                }
                            }
                        }
                        $scope.loadingLapses = false;
                        $scope.$applyAsync();
                    }
                }
                else {
                    //Se primo slot disponibile è precedente alla data di minima validità, esco 
                    if ($scope.filteredLapses[0].From.isSameOrBefore($scope.minValidDate, 'm'))
                        return;
                    if (startdate >= this.now()) {
                        let filtered: ILapseAvailable[] = $scope.allLapses.filter(l => l.From.isBefore(startdate) && l.From.isSameOrAfter($scope.minValidDate));
                        if (filtered.length > 0 && !isFirstRun && !nextDay) {
                            $scope.filteredLapses = filtered.slice(-MAXRESULTS);

                            if ($scope.cutMinMaxDates && this.min?.isValid()) {
                                $scope.filteredLapses = $scope.filteredLapses.filter(x => x.From > this.min);
                                let f = $scope.allLapses.filter(x => x.From < $scope.filteredLapses[0]?.From);
                                let nextNonVisibleSlot = f.length > 0 ? f.lastElement() : null;
                                $scope.passedMinDate = nextNonVisibleSlot && nextNonVisibleSlot.From.isValid && nextNonVisibleSlot.From <= this.min;
                            }
                        } else {
                            if (startdate.isSame(this.now(), 'day')) {
                                $scope.waitPrevious = true;
                                return;// grigio dietro
                            }
                            $scope.data.startdate = moment.tz(startdate.clone().subtract('d', 1), this.TZ).startOf('day');

                            $scope.waitPrevious = true;
                            $scope.loadingLapses = true;
                            const res = await genericHelper.$http.post<any>('/Booking/Book/GetData', {
                                Date: TargetToLocal($scope.data.startdate, this.TZ), //moment.tz($scope.data.startdate, this.TZ),
                                PlantId: $scope.plantId, direction: direction
                            });
                            $scope.currentData = res.data;
                            $scope.productGroupsValues = res.data.productGroups.map((pg: any) => ({ Code: pg.Code.trim(), Name: pg.Name.trim(), Value: 0, Limit: pg.Limit }));
                            $scope.waitPrevious = false;
                            $scope.docksLimit = res.data.MaxDocks;
                            $scope.cutMinMaxDates = res.data.CutMinMaxDates;

                            //Rende libero lo slot della prenotazione da modificare
                            if (filterCode)
                                $scope.currentData.rows = $scope.currentData.rows.map((a: any) => ({
                                    ...a,
                                    Ships: a.Ships.filter((b: any) => b.Code != filterCode)
                                }));

                            for (var d of $scope.currentData.rows) {
                                d.Ships.forEach((s: any) => {
                                    // Prima non era presente .utc()
                                    s.ExpStartLoad = s2m(s.ExpStartLoad).utc().format();
                                    s.ExpEndLoad = s2m(s.ExpEndLoad).utc().format();
                                    s.RePlanned = s2m(s.RePlanned).utc().format();
                                    // Reset volume per successivo ricalcolo
                                    s.Volume = 0;
                                })
                            }

                            manageRemainingDays(direction, startdate);

                            //Recuperiamo tutte le handling unit presenti fra le prenotazioni della giornata, nel caso sia presente comboGroup con ProductCode == null (*)
                            const cgWithAnyProd = (<ComboGroup[]>$scope.currentData.cg).some(x => x.ProductCode == null);
                            let allShipsProdTypes = [];
                            if (cgWithAnyProd)
                                allShipsProdTypes = Array.from(new Set((<any[]>$scope.currentData.rows).flatMap((x: any) => (<any[]>x.Ships).flatMap((y: any) => (<any[]>y.Items).flatMap((z: any) => z.Product_Code)))));
                            //Chiamata per calcolare volume
                            const productList = new Set(
                                Array.from(
                                    (<ComboGroup[]>$scope.currentData.cg)
                                        .map(x => x.ProductCode))
                                    .concat($scope.products.map(p => p.Code))
                                    .concat(allShipsProdTypes)
                                    .filter(x => x));
                            //Chiamata per calcolare volume
                            if (!this.volume || !this.volume.data)
                                this.volume = await $http.post<{ [key: string]: number }>('/Booking/Book/CalculateVolume', {
                                    products:
                                        Array.from(productList)
                                            .map(x => ({ productCode: x, quantity: 0 })),
                                    plantId: $scope.plantId
                                });
                            let avail = U.filterComboGroups((<ComboGroup[]>$scope.currentData.cg), $scope.products, $scope.data.selectedTruckType, this.volume.data);
                            if (avail) {
                                avail = avail.map(x => ({
                                    ...x,
                                    From: TargetToLocal(moment(x.From), this.TZ),
                                    To: TargetToLocal(moment(x.To), this.TZ)
                                }));
                                //avail.From = TargetToLocal(moment(avail.From), this.TZ);
                                //avail.To = TargetToLocal(moment(avail.To), this.TZ);
                            }


                            $scope.allLapses = (<ILapseAvailable[]>FindTimeLapses({
                                rows: $scope.currentData.rows,
                                date: moment.invalid(),
                                OpeningTime: moment.tz($scope.currentData.OpeningTime, this.TZ), //moment.tz($scope.currentData.OpeningTime, this.TZ),
                                ClosingTime: moment.tz($scope.currentData.ClosingTime, this.TZ),//moment.tz($scope.currentData.ClosingTime, this.TZ)
                                dockGroups: $scope.currentData.dockGroups,
                                comboGroups: avail,
                                expectedVolume: this.volume.data
                            },
                                $scope.effDuration,
                                [],
                                // se sono in edit non considero idle time fra spedizioni
                                filterCode ? 0 : $scope.currentData.MininumDelay,
                                $scope.duration,
                                $scope.docksLimit))
                                .filter(l => U.BondGate(
                                    <IDockLapse>{ Code: l.Code }
                                    , $scope.products
                                    , $scope.data.selectedTruckType
                                    , moment.tz($scope.currentData.OpeningTime, this.TZ)
                                    , JSON.parse(res.data.x)))
                                .filter(l => l.From.isSameOrAfter($scope.minValidDate))
                                .reduce((cum: ILapseAvailable[], next: ILapseAvailable) => {
                                    if (!cum.some(c => c.From.isSame(next.From, 'minute')))
                                        cum.push(next);
                                    return cum;
                                }, []);

                            blockSearch(startdate);

                            if ($scope.allLapses.length == 0) {
                                await recheckRes(startdate.clone().subtract('d', 1), Direction.Backward);
                            }

                            else {
                                $scope.errorMessage = '';
                                $scope.filteredLapses = $scope.allLapses.slice(-MAXRESULTS);
                                nextDateDay = $scope.filteredLapses[0].From.clone().startOf('d');

                                if ($scope.cutMinMaxDates && this.min?.isValid()) {
                                    if ($scope.filteredLapses[$scope.filteredLapses.length - 1].From < this.min) {
                                        $scope.filteredLapses[$scope.filteredLapses.length - 1].From.clone().add(1, 'd');
                                        await recheckRes($scope.filteredLapses[$scope.filteredLapses.length - 1].From, Direction.Forward);
                                    }
                                }
                            }
                            $scope.loadingLapses = false;
                            $scope.$applyAsync();
                        }
                    }
                }
                try {
                    const acts: string[] = [];
                    const origs: string[] = [];
                    let type = '';
                    $scope.products.forEach(a => {
                        acts.push(a.TripType);
                        origs.push(a.Destination);
                        if (!type)
                            type = a.Type;
                        else
                            type += '|' + a.Type;
                    });
                    const saf = await genericHelper.$http.post<{ StartDate: string, EndDate: string, BookingTollerance: number }[]>('/Booking/Book/MaxDelay', {
                        PlantId: $scope.plantId,
                        ShipmentTypes: acts,
                        OriginDestinations: origs,
                        Truck: $scope.data.selectedTruckType,
                        ActivityType: type,
                        From: moment.tz($scope.currentData.OpeningTime, this.TZ).toISOString(),
                        To: moment.tz($scope.currentData.ClosingTime, this.TZ).toISOString()
                    });
                    this.delays = saf.data.map(a => ({
                        BookingTollerance: a.BookingTollerance,
                        StartDate: moment.tz(a.StartDate, this.TZ),
                        EndDate: a.EndDate ? moment.tz(a.EndDate, this.TZ) : null
                    }));
                } catch {
                    this.delays = [];
                } finally {
                    $scope.maxlimit = NaN;
                }

                // tengo traccia di quale e' il primo slot proposto in assoluto da load manager
                if (this.firstProposedSlot == null)
                    this.firstProposedSlot = $scope.filteredLapses[0].From;

                //const searchData = moment.tz($scope.data.selecteddate, 'YYYY/MM/DD', this.TZ).startOf('d').add($scope.data.selectedtime, 'h');
                //console.log(searchData);

            };

            $scope.refreshSlots = async (filterCode: string) => {
                //Resettiamo tutte le date
                const searchData = nextDateDay = moment.tz($scope.data.selecteddate, 'YYYY/MM/DD', this.TZ).startOf('d').add($scope.data.selectedtime, 'h');
                $scope.canSave = false;
                $scope.recheckResults(searchData, Direction.Forward, true, filterCode ? filterCode : '');
            }

            $scope.saveBooking = (loc?: CustomerPlant) => {
                const plantId: CustomerPlant = loc || this.getCustomerPlant();
                const lapseSelected = $scope.filteredLapses.find(l => l.Selected);
                $scope.showLoading = true;
                if ($scope.canSave) {
                    if (!$scope.bookingCode)
                        //genericHelper.$http.get<number>(`/Booking/Book/IsOverbooking?plantId=${plantId.Id}&bookHour=${LocalToTarget(lapseSelected.From, this.TZ).toJSON()}&gateId=${lapseSelected.Code}&duration=${$scope.duration}`).then(res => {
                        genericHelper.$http.get<number>(`/Booking/Book/IsOverbooking?plantId=${plantId.Id}&bookHour=${lapseSelected.From.toJSON()}&gateId=${lapseSelected.Code}&duration=${$scope.effDuration}`).then(res => {
                            let selectedDateTime = moment.tz($scope.data.selecteddate, 'YYYY/MM/DD', this.TZ).startOf('d').add($scope.data.selectedtime, 'h')
                            if (!!+res.data) {
                                $scope.allLapses = $scope.filteredLapses = [];
                                $scope.newBookingError = true;
                                $scope.recheckResults(selectedDateTime, Direction.Forward, true);
                                //WizardHandler.wizard().previous();
                                alert('Slot no more available, please select another arrival time');
                                $scope.showLoading = false;
                            } else {

                                let firstProposedSlot = this.firstProposedSlot;
                                let selectedTimeSlot = $scope.initialDateTime;
                                genericHelper.$http.post<any>('/Booking/Book/NewBooking', {
                                    //UnlockCode: $scope.prebookings.reduce((prev: string, cur: LM.Prebooking & IBookingData) => prev ? prev += ` - ${cur.unlockCode}` : prev = cur.unlockCode,''),//this.prebooked && this.prebooked.unlockCode,
                                    PlantId: plantId.Id,
                                    StartDT: lapseSelected.From,
                                    EndDT: moment(lapseSelected.From).add($scope.effDuration, 'm'),
                                    Destination: '01',
                                    Truck: $scope.data.selectedTruckType,
                                    TripType: '01',
                                    Items: $scope.products.map(p => ({
                                        PackageType: p.Code,
                                        Quantity: p.Value,
                                        DestinationCountry: p.Destination,
                                        TripType: p.TripType,
                                        Action: p.Type
                                    })),
                                    gateCode: lapseSelected.Code,
                                    Carrier: this.getField('carrier'),
                                    PhoneNumber: this.getField('phonenumber'),
                                    Nation: this.getField('country'),
                                    CDN: $scope.data.refnum.toUpperCase(),//(this.prebooked ? this.prebooked.shipmentCode : $scope.data.refnum).toUpperCase(),
                                    Email: $scope.data.email,
                                    TruckPlate: this.getField('truckplate'),
                                    TrailerPlate: this.getField('trailerplate'),
                                    Notes: $scope.data.notes,
                                    Sender: this.getField('sender'),
                                    Receiver: this.getField('receiver'),
                                    ReferenceName: this.getField('refname'),
                                    External: this.getField('external'),
                                    FilePath: $scope.bookingFilePath,
                                    Recaptcha: recaptchaResponse,
                                    Prebookings: $scope.prebookings.length > 0 ? $scope.prebookings.map(p => <any>{ ShipmentCode: p.shipCode, UnlockCode: p.unlockCode }) : [],
                                    FirstProposedSlot: firstProposedSlot,
                                    SelectedTimeSlot: selectedTimeSlot
                                }).then(res => {
                                    if (res.data.Error) {
                                        if (res.data.Error.indexOf("Empty Captcha") > -1) {
                                            recaptchaResponse = "MULTI_BK";
                                            $scope.saveBooking(loc);
                                        }
                                        else {
                                            alert('Booking process has encountered some error. Please try again.' + res.data.Error);
                                        }
                                        //location.reload();
                                    } else {
                                        $scope.shipment = res.data.shipment;
                                        document.getElementById('ticket').innerHTML = res.data.HtmlTemplate;
                                        for (let i = 0; i < $scope.shipment.Items.length; i++) {
                                            $scope.productsPreviewStrings.push(ActionType[$scope.shipment.Items[i].Action] + ': ' + $scope.shipment.Items[i].Product_Code + '[' + $scope.shipment.Items[i].Quantity + ']')
                                            //$scope.productsPreviewStrings.push($scope.shipment.Items[i].LoadUnload + ': ' + $scope.shipment.Items[i].Product_Code + '[' + $scope.shipment.Items[i].Quantity + ']')
                                        }
                                        $scope.shipment.Items.forEach((i: any) => $scope.totQty += i.Quantity);
                                        $scope.bookingCode = $scope.shipment.Code;
                                        //const qrcode = new QRCode(document.getElementById('qrcode'), { height: 100, width: 100 });
                                        //qrcode.makeCode($scope.shipment.TicketUrl.toString());
                                        // @ts-ignore

                                        //-----------------------------
                                        //QRCode.toCanvas(document.getElementById('qrcode'), $scope.shipment.TicketUrl.toString(), { width: 100 });
                                        //JsBarcode('#barcode', $scope.shipment.Code, { height: 30, width: 1, displayValue: false });

                                        $scope.formLink = res.data.FormLink;
                                        $scope.formLabel = res.data.FormLabel;
                                        $scope.downloadPdf($scope.bookingCode);
                                        //Versione originale, sembra che i parametri passati siano nulli
                                        //$scope.hubSR.UpdateShip(res.data.pIdC, res.data.dbIdC);
                                        $scope.showLoading = false;
                                        if (!$scope.skip) {
                                            WizardHandler.wizard().next();
                                        } else {
                                            WizardHandler.wizard().goTo("End");
                                        }
                                        $scope.hubSR.UpdateShip(res.data.pId, res.data.dbId);
                                        //comunico con portale
                                        if (window.location !== window.parent.location) {
                                            // The page is an iframe
                                            window.parent.postMessage(JSON.stringify($scope.shipment), '*');
                                        }
                                    }
                                });
                            }
                        })
                }
            };

            $scope.selectLapse = (lapse: ILapseAvailable) => {
                $scope.sameDaySlot = this.selectLapse(lapse);
                $scope.canSave = true;
                const obj = this.delays.find(a => lapse.From.isSameOrAfter(a.StartDate) && (!a.EndDate || lapse.From.isBefore(a.EndDate)));
                if (obj)
                    $scope.maxlimit = obj.BookingTollerance;
                else
                    $scope.maxlimit = NaN;
            };

            $scope.validates2 = function () {
                if (!$scope.validateTruckType())
                    return false;
                if ($scope.products.length == 0)
                    return $scope.atleastOne = false;
                return document.getElementsByClassName('wrong-s2').length <= 0;
            };

            $scope.validates3 = function () {
                if (!$scope.validateTruckType())
                    return false;
                if ($scope.products.length == 0)
                    return $scope.atleastOne = false;
                return document.getElementsByClassName('wrong-s3').length <= 0;
            };
            $scope.prebooking = false;
            $scope.is_prebooked = false;
            $scope.prebookedstatus = 0;
            $scope.is_privacy_checked = function () {
                const ACTUAL_PRIVACY_VERSION = "2";
                const KEY_PRIVACY_LOCAL_STORAGE = "load_manager_privacy_version";
                const privacy_version = BookingBase.getFromLocalStorage(KEY_PRIVACY_LOCAL_STORAGE);
                if (privacy_version == "" || privacy_version < ACTUAL_PRIVACY_VERSION) {
                    //const match = decodeURIComponent(document.cookie).match(/\.User\.Locale=([^;]+);?/);
                    //const lng = Array.isArray(match) ? match[1] : 'en';
                    const lng = LangService.getLanguage();
                    const customPrivacy = $scope.customPrivacy;
                    $uibModal.open({
                        templateUrl: '/Templates/PrivacyVerification.html',
                        controller: ['$scope', (function ($scope: any) {
                            $scope.set_privacy = () => {
                                BookingBase.saveFieldInLocalStorage(KEY_PRIVACY_LOCAL_STORAGE, ACTUAL_PRIVACY_VERSION);
                            };
                            $scope.chg = () => {
                                console.log("Custom privacy :" + JSON.stringify(customPrivacy));
                                LangService.selectLanguage($scope.language);
                                location.reload();
                            };
                            $scope.language = lng;
                            $scope.content = {
                                privacy_selected_value: "", localstorage_selected_value: "",
                                isCustomPrivacy: !!customPrivacy,
                                privacyIt: customPrivacy ? customPrivacy.privacyIt : "",
                                privacyEn: customPrivacy ? customPrivacy.privacyEn : "",
                                privacyLinkIt: customPrivacy ? customPrivacy.privacyLinkIt : "",
                                privacyLinkEn: customPrivacy ? customPrivacy.privacyLinkEn : "",
                                cookieIt: customPrivacy ? customPrivacy.cookieIt : "",
                                cookieEn: customPrivacy ? customPrivacy.cookieEn : "",
                                cookieLinkIt: customPrivacy ? customPrivacy.cookieLinkIt : "",
                                cookieLinkEn: customPrivacy ? customPrivacy.cookieLinkEn : "",
                            };
                            $scope.gdprLink = () => {
                                switch ($scope['language']) {
                                    case 'it':
                                        return 'informativa-gdpr';
                                    case 'en':
                                    default:
                                        return 'informativa-gdpr-en';
                                }
                            };
                            $scope.cookieLink = () => {
                                switch ($scope['language']) {
                                    case 'it':
                                        return 'informativa-cookie-policyr';
                                    case 'en':
                                    default:
                                        return 'informativa-cookie-policy-en';
                                }
                            };
                        })],
                        backdrop: 'static'
                    }).result.catch(() => location.reload());
                    return false;
                }
                return true;
            }

            $scope.navigation_wizard_enabled = function () {
                if (!$scope.is_privacy_checked()) {
                    location.reload();
                }
                return WizardHandler.wizard().currentStep().wzTitle !== 'End' || $scope.newBookingError;
            };

            $scope.validateTruckType = function () {
                return !!$scope.data.selectedTruckType;
            };

            $scope.validateValue = function (value: string) {
                if (!value || value == '0')
                    return false;
                return true;
            };

            $scope.triggerQuantity = function (product) {
                if (!product || !product.Code)
                    return false
                const limit = $scope.getProductLimit(product.Code);
                return (limit && limit < product.Value);
            }

            $scope.getProductLimit = (productCode: string) => $scope.productGroupsValues.find(x => x.Code == productCode)?.Limit;

            $scope.addProductRow = () => {
                if (!$scope.loadUnloadEnabled && $scope.products.length > 0)
                    $scope.loadUnload = $scope.loadUnload.filter(lu => (<any>lu).name == $scope.products[0].Type);
                else
                    $scope.loadUnload = $scope.origLoadUnload;
                if ($scope.checkScreensize()) {
                    let modalInstance = $uibModal.open({
                        templateUrl: '/Templates/AddItemModal.html',
                        controller: ['$scope', function ($scope: any) {
                            $scope.data = $scope.$resolve.data;
                            $scope.parentScope = $scope.$resolve.parentScope;

                            var code = '';
                            var type = '';
                            var destination = '';
                            var trip = '';

                            if ($scope.data.productGroupsValues && !$scope.parentScope.isColumnVisible("Product")) {
                                if ($scope.data.productGroupsValues.length == 1) {
                                    code = $scope.data.productGroupsValues[0].Code;
                                } else {
                                    $scope.parentScope.columnVisibilityError = true;
                                }
                            }
                            if ($scope.data.loadUnload && !$scope.parentScope.isColumnVisible("Type")) {
                                if ($scope.data.loadUnload.length == 1) {
                                    type = $scope.data.loadUnload[0].name;
                                } else {
                                    $scope.parentScope.columnVisibilityError = true;
                                }
                            }
                            if ($scope.data.tripTypes && !$scope.parentScope.isColumnVisible("Deliver method")) {
                                if ($scope.data.tripTypes.length == 1) {
                                    trip = $scope.data.tripTypes[0].Name;
                                } else {
                                    $scope.parentScope.columnVisibilityError = true;
                                }
                            }
                            if ($scope.data.destinations && !$scope.parentScope.isColumnVisible("Source/Destination")) {
                                if ($scope.data.destinations.length == 1) {
                                    destination = $scope.data.destinations[0].Name;
                                } else {
                                    $scope.parentScope.columnVisibilityError = true;
                                }
                            }


                            if (!$scope.parentScope.isColumnVisible("Quantity")) {
                                $scope.item = { Type: type, Code: code, TripType: trip, Destination: destination, Name: '', Value: 1 };
                            } else {
                                $scope.item = { Type: type, Code: code, TripType: trip, Destination: destination, Name: '' };
                            }
                            $scope.OkBtn = function (elem: BookingProduct) {
                                $scope.$close(elem);
                            }
                        }],
                        controllerAs: '$ctrl',
                        resolve: {
                            data: () => <any>{
                                productGroupsValues: $scope.productGroupsValues,
                                loadUnload: $scope.loadUnload,
                                destinations: $scope.destinations,
                                tripTypes: $scope.tripTypes,
                                customerCode: $scope.customerCode
                            },
                            parentScope: $scope
                        },
                        size: 'sm'
                    });
                    modalInstance.result.then((res: any) => {
                        $scope.products.push(res);
                    });
                }
                else {
                    var code = '';
                    var type = '';
                    var destination = '';
                    var trip = '';

                    //SE LA COLONNA NON è VISIBILE E C'è SOLO UN VALORE POSSIBILE LO SETTO, ALTRIMENTI NON POSSO PROSEGUIRE

                    if ($scope.productGroupsValues && !$scope.isColumnVisible("Product")) {
                        if ($scope.productGroupsValues.length == 1) {
                            code = $scope.productGroupsValues[0].Code;
                        } else {
                            $scope.columnVisibilityError = true;
                        }
                    }
                    if ($scope.loadUnload && !$scope.isColumnVisible("Type")) {
                        if ($scope.loadUnload.length == 1) {
                            type = $scope.loadUnload[0].name;
                        } else {
                            $scope.columnVisibilityError = true;
                        }
                    }
                    if ($scope.tripTypes && !$scope.isColumnVisible("Deliver method")) {
                        if ($scope.tripTypes.length == 1) {
                            trip = $scope.tripTypes[0].Name;
                        } else {
                            $scope.columnVisibilityError = true;
                        }
                    }
                    if ($scope.destinations && !$scope.isColumnVisible("Source/Destination")) {
                        if ($scope.destinations.length == 1) {
                            destination = $scope.destinations[0].Name;
                        } else {
                            $scope.columnVisibilityError = true;
                        }
                    }

                    if (!$scope.isColumnVisible("Quantity")) {
                        $scope.products.push({ Code: code, Type: type, Destination: destination, TripType: trip, Value: 1 });
                    } else {
                        $scope.products.push({ Code: code, Type: type, Destination: destination, TripType: trip });
                    }
                }
                $scope.atleastOne = true;
            };

            $scope.editProductRow = (product: any) => {
                $uibModal.open({
                    templateUrl: '/Templates/EditItemModal.html',
                    controller: ['$scope', function ($scope: any) {
                        $scope.data = $scope.$resolve.data;
                        $scope.product = $scope.$resolve.product;
                        $scope.OkBtn = function (elem: BookingProduct) {
                            $scope.$close(elem);
                        }
                    }],
                    controllerAs: '$ctrl',
                    resolve: {
                        data: () => <any>{
                            productGroupsValues: $scope.productGroupsValues,
                            loadUnload: [{ name: 'Load' }, { name: 'Unload' }],
                            destinations: $scope.destinations,
                            tripTypes: $scope.tripTypes
                            //customerCode: $scope.customerCode
                        },
                        product: () => product //angular.copy(product)
                    }
                });
            };

            $scope.removeRow = (product: any) => {
                $scope.products.splice($scope.products.indexOf(product), 1);
                if ($scope.products.length == 0)
                    $scope.atleastOne = false;
            };

            $scope.checkScreensize = () => {
                if (navigator.userAgent.match(/Android/i)
                    || navigator.userAgent.match(/webOS/i)
                    || navigator.userAgent.match(/iPhone/i)
                    //|| navigator.userAgent.match(/iPad/i)
                    || navigator.userAgent.match(/iPod/i)
                    || navigator.userAgent.match(/BlackBerry/i)
                    || navigator.userAgent.match(/Windows Phone/i))
                    return true;
            };

            $scope.downloadPdf = (bookingCode: string) => {
                const link = document.createElement('a');
                link.href = '/Booking/Book/DownloadCustomPdf?shipmentCode=' + bookingCode + ($scope.linkId ? '&linkId=' + $scope.linkId : '');
                link.attributes.setNamedItem(document.createAttribute('download'));
                link.click();
            };

            $scope.mandAttachments = (group: number) => {
                const attachField = $scope.mandatoryFieldsList?.find(f => (<any>LM.ActionType)[f.Workflow] == this.actionWf)?.Fields.find(f => f.FormName == 'attachments' + group.toString());
                var r = $scope.mandatoryFieldsList && this.actionWf &&
                    attachField.Mandatory === 'true' && attachField.Visible === 'true' &&
                    ((!$scope.attachments1Count && group == 1) || (!$scope.attachments2Count && group == 2) || (!$scope.attachments3Count && group == 3));
                return r;
            }

            $scope.PrintPDF = (bookingCode: string) => {
                window.open('/Booking/Book/DownloadCustomPdf?shipmentCode=' + bookingCode + ($scope.linkId ? '&linkId=' + $scope.linkId : '') + '&download_for_print=true', '_blank');
            };

            $scope.uploader1.onAfterAddingAll = () => {
                $scope.allowPdfDownload = false;
                $scope.upload(1);
            };

            $scope.uploader2.onAfterAddingAll = () => {
                $scope.allowPdfDownload = false;
                $scope.upload(2);
            };

            $scope.uploader3.onAfterAddingAll = () => {
                $scope.allowPdfDownload = false;
                $scope.upload(3);
            };

            $scope.upload = async (group: number) => {
                $scope.allowPdfDownload = true;
                const uploaderFiles = (<HTMLInputElement>document.getElementById('upload' + '-' + group)).files;
                for (let i: number = 0; i < uploaderFiles.length; i++) {
                    $scope.uploadSuccess = false;
                    let form = new FormData();
                    let item = uploaderFiles.item(i);
                    form.append('id', $scope.filePath);
                    form.append('cc', $scope.customerCode);
                    form.append('file', item, item.name);
                    form.append('group', group.toString());
                    //Reset error message
                    if (group == 1) {
                        $scope.fileUploadError1 = "";
                        $scope.fileNotLoadedYet1.push(item.name);
                    }
                    if (group == 2) {
                        $scope.fileUploadError2 = "";
                        $scope.fileNotLoadedYet2.push(item.name);
                    }
                    if (group == 3) {
                        $scope.fileUploadError3 = "";
                        $scope.fileNotLoadedYet3.push(item.name);
                    }
                    $http<any>({
                        method: 'POST',
                        url: '/Booking/Book/UploadFile/',
                        data: form,
                        headers: {
                            'Content-Type': void 0
                        }
                    }).then(function (response) {
                        if (group == 1) {
                            $scope.fileNotLoadedYet1.splice($scope.fileNotLoadedYet1.findIndex(f => f == item.name), 1);
                        }
                        if (group == 2) {
                            $scope.fileNotLoadedYet2.splice($scope.fileNotLoadedYet2.findIndex(f => f == item.name), 1);
                        }
                        if (group == 3) {
                            $scope.fileNotLoadedYet3.splice($scope.fileNotLoadedYet3.findIndex(f => f == item.name), 1);
                        }
                        if (response.data.status == "OK") {
                            $scope.bookingFilePath = response.data.message;

                            if (group == 1) {
                                $scope.attachments1Count++;
                            }
                            if (group == 2) {
                                $scope.attachments2Count++;
                            }
                            if (group == 3) {
                                $scope.attachments3Count++;
                            }
                        }
                        else {
                            if (group == 1) {
                                if (!$scope.fileUploadError1)
                                    $scope.fileUploadError1 = response.data.message;
                                $scope.uploader1.queue.splice($scope.uploader1.queue.findIndex((a: any) => a._file == item), 1)
                            }
                            if (group == 2) {
                                if (!$scope.fileUploadError2)
                                    $scope.fileUploadError2 = response.data.message;
                                $scope.uploader2.queue.splice($scope.uploader2.queue.findIndex((a: any) => a._file == item), 1)
                            }
                            if (group == 3) {
                                if (!$scope.fileUploadError3)
                                    $scope.fileUploadError3 = response.data.message;
                                $scope.uploader3.queue.splice($scope.uploader3.queue.findIndex((a: any) => a._file == item), 1)
                            }
                        }
                        //$scope.uploader.clearQueue();
                    });
                }
            };

            $scope.isInUploadingPhase1 = (file: any) => {
                return $scope.fileNotLoadedYet1.findIndex(f => f == file) > 0;
            }
            $scope.isInUploadingPhase2 = (file: any) => {
                return $scope.fileNotLoadedYet2.findIndex(f => f == file) > 0;
            }
            $scope.isInUploadingPhase3 = (file: any) => {
                return $scope.fileNotLoadedYet3.findIndex(f => f == file) > 0;
            }

            $scope.deleteFile = (file: any, group: number) => {
                const fp = `Temp/${$scope.customerCode}/${$scope.filePath}/${file.file.name}`;
                genericHelper.$http.delete('/Booking/Book/DeleteFile/' + btoa(fp)).then(res => {
                    if (group == 1) {
                        $scope.uploader1.removeFromQueue(file);
                        $scope.attachments1Count--;
                    }
                    if (group == 2) {
                        $scope.uploader2.removeFromQueue(file);
                        $scope.attachments2Count--;
                    }
                    if (group == 3) {
                        $scope.uploader3.removeFromQueue(file);
                        $scope.attachments3Count--;
                    }
                });
            };

            $scope.fillFields = function () {
                //$scope.data.email = BookingBase.fillFieldFromLocalStorage('email');
                //EMAIL CHECK WHITELIST
                //$scope.checkEmail($scope.data.email);
                //$scope.data.selectedTruckType = BookingBase.fillFieldFromLocalStorage('truckType');
                $scope.data.carrier = BookingBase.fillFieldFromLocalStorage('carrier');
                $scope.data.external = BookingBase.fillFieldFromLocalStorage('external');
                $scope.data.refname = BookingBase.fillFieldFromLocalStorage('refname');
                $scope.data.refnum = BookingBase.fillFieldFromLocalStorage('refnum');
                $scope.data.truckplate = BookingBase.fillFieldFromLocalStorage('truckplate');
                $scope.data.trailerplate = BookingBase.fillFieldFromLocalStorage('trailerplate');
                $scope.data.phonenumber = BookingBase.fillFieldFromLocalStorage('phonenumber');
                $scope.data.notes = BookingBase.fillFieldFromLocalStorage('notes');
                $scope.data.sender = BookingBase.fillFieldFromLocalStorage('sender');
                $scope.data.receiver = BookingBase.fillFieldFromLocalStorage('receiver');
            };

            $scope.PrintElem = function (elem: string) {
                const mywindow = window.open('', 'PRINT', 'height=580,width=339');
                mywindow.document.write('<html><head><title>' + document.title + '</title>',
                    '<link rel="stylesheet" type ="text/css" href="/Content/MyFontsWebfontsKit.css"/>',
                    '<link rel="stylesheet" type ="text/css" href="/Content/bookPrenotation.css"/>',
                    '<style>.printout {width:100%;} #shipCode {transform: rotate(270deg);top:110px !important;position:absolute} body * {font-family: Larsseit;}</style>',
                    '</head><body >',
                    document.getElementById(elem).innerHTML,
                    '</body></html>');

                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/
                setTimeout(() => mywindow.print(), 500);
                return true;
            };

            $scope.getUploadedPdf = function (pdfName) {
                location.href = '/Booking/Book/downloadUploadedPdf?dir=' + $scope.filePath + '&fileName=' + encodeURIComponent(pdfName) + '&cc=' + $scope.customerCode;
            };

            $scope.checkConditions = function () {
                $scope.canSave = $scope.data.privacySelectedValue == 'Agree' && $scope.filteredLapses.some(l => l.Selected);
            };

            $scope.sanitize = () => {
                //$scope.data.phonenumber = $sanitize($scope.data.phonenumber);
                //$scope.data.carrier = $sanitize($scope.data.carrier);
                //$scope.data.refname = $sanitize($scope.data.refname);
                //$scope.data.refnum = $sanitize($scope.data.refnum);
                //$scope.data.truckplate = $sanitize($scope.data.truckplate);
                //$scope.data.trailerplate = $sanitize($scope.data.trailerplate);
                //$scope.data.sender = $sanitize($scope.data.sender);
                //$scope.data.receiver = $sanitize($scope.data.receiver);
                //$scope.data.notes = $sanitize($scope.data.notes);

                /////////////
                this.saveStep(3);
                /////////////
            };


            $scope.showTooltip = (fieldName: string) => {
                if ($scope.mandatoryFieldsList && this.actionWf) {
                    const field = $scope.mandatoryFieldsList.find(f => (<any>LM.ActionType)[f.Workflow] == this.actionWf).Fields.find(f => f.Field == fieldName);
                    switch (LangService.getLanguage()) {
                        case ("it"):
                            if (field.TooltipIT)
                                return field.TooltipIT;
                            break;
                        case ('en'):
                            if (field.TooltipEN)
                                return field.TooltipEN;
                            break;
                        case ('es'):
                            if (field.TooltipES)
                                return field.TooltipES;
                            break;
                        case ('de'):
                            if (field.TooltipDE)
                                return field.TooltipDE;
                            break;
                        case ('fr'):
                            if (field.TooltipFR)
                                return field.TooltipFR;
                            break;
                        case ('pl'):
                            if (field.TooltipPL)
                                return field.TooltipPL;
                            break;
                        case ('ro'):
                            if (field.TooltipRO)
                                return field.TooltipRO;
                            break;
                        case ('ru'):
                            if (field.TooltipRU)
                                return field.TooltipRU;
                            break;
                    }
                    return fieldName;
                }
            }

            $scope.showLabel = (fieldName: string) => {
                if ($scope.mandatoryFieldsList && this.actionWf) {
                    const field = $scope.mandatoryFieldsList.find(f => (<any>LM.ActionType)[f.Workflow] == this.actionWf).Fields.find(f => f.Field == fieldName);
                    switch (LangService.getLanguage()) {
                        case ("it"):
                            if (field.LabelIT)
                                return field.LabelIT;
                            break;
                        case ('en'):
                            if (field.LabelEN)
                                return field.LabelEN;
                            break;
                        case ('es'):
                            if (field.LabelES)
                                return field.LabelES;
                            break;
                        case ('de'):
                            if (field.LabelDE)
                                return field.LabelDE;
                            break;
                        case ('fr'):
                            if (field.LabelFR)
                                return field.LabelFR;
                            break;
                        case ('pl'):
                            if (field.LabelPL)
                                return field.LabelPL;
                            break;
                        case ('ro'):
                            if (field.LabelRO)
                                return field.LabelRO;
                            break;
                        case ('ru'):
                            if (field.LabelRU)
                                return field.LabelRU;
                            break;
                    }
                    return fieldName;
                }
            }
            $scope.showProductLabel = (fieldName: string) => {
                if ($scope.bookingFieldLabels) {
                    const field = $scope.bookingFieldLabels.Fields.find(f => f.Field == fieldName);
                    switch (LangService.getLanguage()) {
                        case ("it"):
                            if (field.LabelIT)
                                return field.LabelIT;
                            break;
                        case ('en'):
                            if (field.LabelEN)
                                return field.LabelEN;
                            break;
                        case ('es'):
                            if (field.LabelES)
                                return field.LabelES;
                            break;
                        case ('de'):
                            if (field.LabelDE)
                                return field.LabelDE;
                            break;
                        case ('fr'):
                            if (field.LabelFR)
                                return field.LabelFR;
                            break;
                        case ('pl'):
                            if (field.LabelPL)
                                return field.LabelPL;
                            break;
                        case ('ro'):
                            if (field.LabelRO)
                                return field.LabelRO;
                            break;
                        case ('ru'):
                            if (field.LabelRU)
                                return field.LabelRU;
                            break;
                    }
                    return fieldName;
                }
            }
            $scope.isColumnVisible = (fieldName: string) => {
                if ($scope.bookingFieldLabels) {
                    const field = $scope.bookingFieldLabels.Fields.find(f => f.Field == fieldName);
                    if (field) {
                        return field.Visible.toUpperCase() == 'TRUE';
                    }
                    return false;
                }
            }
            $scope.isVisible = (field: string) =>
                $scope.mandatoryFieldsList && this.actionWf &&
                $scope.mandatoryFieldsList.find(f => (<any>LM.ActionType)[f.Workflow] == this.actionWf).Fields.find(f => f.FormName == field).Visible === 'true';

            $scope.isMandatory = (field: string, value: string) =>
                $scope.mandatoryFieldsList && this.actionWf &&
                $scope.mandatoryFieldsList.find(f => (<any>LM.ActionType)[f.Workflow] == this.actionWf).Fields.find(f => f.FormName == field).Mandatory === 'true' &&
                !$scope.validateValue(value);

            $scope.isEditable = (field: string) =>
                $scope.mandatoryFieldsList && this.actionWf &&
                $scope.mandatoryFieldsList.find(f => (<any>LM.ActionType)[f.Workflow] == this.actionWf).Fields.find(f => f.FormName == field).Editable === 'true';

            $scope.checkEmail = (email: string) => {
                if (!email)
                    return;
                genericHelper.$http.post<EmailStatus>('/EmailVerification/CheckEmail', { email: email, databaseId: $scope.customerCode, plantCode: $scope.plantCode }).then(res => {
                    $scope.emailValid = res.data != EmailStatus.BlackList && res.data != EmailStatus.Existing;
                    if (!$scope.emailValid && $scope.InvitationOnly)
                        $uibModal.open({
                            templateUrl: '/Templates/EmailVerification.html',
                            scope: angular.extend($scope.$new(), {
                                email: email,
                                waitSecs: false,
                                content: {
                                    title: this.Language == 'it' ?
                                        'Indirizzo email non abilitato su magazzino' :
                                        "Email address is not enabled for warehouse",
                                    body: this.Language == 'it' ?
                                        `L'indirizzo email inserito non è presente nella lista degli utenti abilitati a prenotarsi su questo magazzino. Contattare il proprio referente.` :
                                        'Email address is not inside the list of enabled addresses for booking. Please contact your reference person.',
                                    resend: false
                                },
                            }),
                            backdrop: 'static'
                        }).result.catch(() => location.reload());
                    else {
                        if ($scope.emailValid)
                            return;
                        $uibModal.open({
                            templateUrl: '/Templates/EmailVerification.html',
                            scope: angular.extend($scope.$new(), {
                                email: email,
                                waitSecs: false,
                                sendEmail: function () {
                                    genericHelper.$http.post('/EmailVerification/SendEmail', { email: email, databaseId: $scope.customerCode, plantCode: $scope.plantCode })
                                        .then(res => {
                                            this.waitSecs = true;
                                            setTimeout(() => { this.waitSecs = false; this.$apply(); /*$scope.$apply();*/ }, 15000);
                                        });
                                },
                                content: res.data == EmailStatus.BlackList ?
                                    {
                                        title: this.Language == 'it' ?
                                            'Indirizzo email non valido o bloccato!' :
                                            'Email address not valid or locked!',
                                        body: this.Language == 'it' ?
                                            'Controllare l\'indirizzo o contattare il magazzino.' :
                                            'Please check email address or contact warehouse.'
                                    } :
                                    {
                                        title: this.Language == 'it' ?
                                            'Mail non verificata!' :
                                            'Email address not verified!',
                                        body: this.Language == 'it' ?
                                            'Abbiamo inviato una mail all\'indirizzo indicato, controllare la propria casella postale.' :
                                            'An email has been sent to the given email address, please check your mailbox.', resend: true
                                    }
                            }),
                            backdrop: 'static'
                        }).result.catch(() => location.reload());
                    }
                });
            };

            $scope.findMultipleShipments = (params: string): void => {
                let cust: CustomerPlant = null;
                if (location.pathname.indexOf("ByPlant") < 0)
                    cust = this.getCustomerPlant();
                else
                    cust = <CustomerPlant>{
                        Id: $scope.plantId
                    }

                $scope.prebooking = true;
                if ($scope.accordionGroup.anchor == '#c') {
                    $scope.accordionGroup.hideFromScratch = true;
                }

                this.GetMultiplePreBook(cust.Id, params, $scope.plantCode).then(values => {
                    for (let q of values) {
                        if (moment(q.booking.selecteddate).isAfter($scope.data.selecteddate))
                            $scope.data.selecteddate = q.booking.selecteddate;
                        $scope.prebookings.push({ ...q.booking, shipCode: q.code, unlockCode: q.pin, products: q.products, minDate: q.booking.mindate, maxDate: q.booking.maxdate });
                        $scope.is_prebooked = true;
                        $scope.prebookedstatus = 1;
                        $scope.prebooking = false;
                        $scope.$apply();
                    }

                    $scope.confirmPrebooking();

                    setTimeout(() => {
                        $scope.prebookedstatus = 0; $scope.$applyAsync();
                    }, 2000);


                }, (err) => {
                    console.log(err);
                    //this.prebooked = null;
                    $scope.is_prebooked = false;
                    $scope.prebooking = false;
                    $scope.prebookedstatus = -1;
                    $scope.$applyAsync();
                    setTimeout(() => { $scope.prebookedstatus = 0; $scope.$applyAsync(); }, 2000);
                });
            };

            $scope.findShipments = (shipmentCode: string, unlockCode: string): void => {
                let cust: CustomerPlant = null;
                if (location.pathname.indexOf("ByPlant") < 0)
                    cust = this.getCustomerPlant();
                else
                    cust = <CustomerPlant>{
                        Id: $scope.plantId
                    }

                $scope.prebooking = true;
                if ($scope.accordionGroup.anchor == '#c') {
                    $scope.accordionGroup.hideFromScratch = true;
                }
                this.GetPreBook(cust.Id, $scope.plantCode, shipmentCode, unlockCode).then(q => {
                    if (moment(q.booking.selecteddate).isAfter($scope.data.selecteddate))
                        $scope.data.selecteddate = q.booking.selecteddate;
                    if (!$scope.prebookings.map(p => p.shipCode).find(a => a.toUpperCase() === shipmentCode.toUpperCase())) {
                        $scope.prebookings.push({ ...q.booking, shipCode: shipmentCode, unlockCode: unlockCode, products: q.products, minDate: q.booking.mindate, maxDate: q.booking.maxdate });
                        $scope.is_prebooked = true;
                        $scope.prebookedstatus = 1;
                        $scope.prebooking = false;
                        $scope.$apply();
                    } else {
                        $scope.prebooking = false;
                    }

                    (<HTMLInputElement>document.getElementsByName('shipCode')[0]).value = '';
                    (<HTMLInputElement>document.getElementsByName('unlockCode')[0]).value = '';
                    setTimeout(() => {
                        $scope.prebookedstatus = 0; $scope.$applyAsync();
                    }, 2000);
                }, (err) => {
                    console.log(err);
                    //this.prebooked = null;
                    $scope.is_prebooked = false;
                    $scope.prebooking = false;
                    $scope.prebookedstatus = -1;
                    $scope.$applyAsync();
                    setTimeout(() => { $scope.prebookedstatus = 0; $scope.$applyAsync(); }, 2000);
                });
            }
            $scope.confirmPrebooking = () => {
                $scope.accordionGroup.existing = false;
                $scope.accordionGroup.fromScratch = true;
                $scope.accordionGroup.hideFromScratch = false;
                $scope.products = [];
                const emails = new Set($scope.prebookings.map(p => p.email).filter(x => x != null && x.length > 0));
                if (emails.size > 1) {
                    $uibModal.open({
                        templateUrl: '/Templates/ChooseEmail.html',
                        scope: angular.extend($scope, {
                            emails: Array.from(emails),
                            email: '',
                            okClose: (email: string) => (<any>$scope).$close(email)
                        }),
                        backdrop: 'static'
                    }).result.then((res: string) => { $scope.data.email = res; $scope.checkEmail(res); });
                } else {
                    $scope.data.email = $scope.prebookings.find(p => p.email)?.email;
                    if ($scope.data.email)
                        $scope.checkEmail($scope.data.email);
                }
                const truckTypes = new Set($scope.prebookings.map(p => p.selectedTruckType));
                if (truckTypes.size > 1)
                    $scope.data.selectedTruckType = '';
                else
                    $scope.data.selectedTruckType = $scope.prebookings.find(p => p.selectedTruckType)?.selectedTruckType;
                $scope.prebookings.forEach((p, i) => {
                    if (Array.isArray(p.products)) {
                        for (let i = 0; i < p.products.length; i++) {
                            $scope.products.push(p.products[i]);
                            $scope.atleastOne = true;
                        }
                    }
                    if (i == 0) {
                        $scope.data.phonenumber = p.phonenumber;
                    }
                    $scope.data.refnum += this.compareFields($scope.data.refnum, p.shipCode);
                    $scope.data.carrier += this.compareFields($scope.data.carrier, p.carrier);
                    $scope.data.country += this.compareFields($scope.data.country, p.country);
                    $scope.data.external += this.compareFields($scope.data.external, p.external);
                    $scope.data.notes += this.compareFields($scope.data.notes, p.notes);
                    $scope.data.receiver += this.compareFields($scope.data.receiver, p.receiver);
                    $scope.data.refname += this.compareFields($scope.data.refname, p.refname);
                    $scope.data.sender += this.compareFields($scope.data.sender, p.sender);
                    $scope.data.trailerplate += this.compareFields($scope.data.trailerplate, p.trailerplate);
                    $scope.data.truckplate += this.compareFields($scope.data.truckplate, p.truckplate);
                    if (moment(p.selecteddate).isAfter($scope.data.selecteddate))
                        $scope.data.selecteddate = p.selecteddate;
                    if (moment($scope.data.selecteddate).isSameOrBefore(moment(), 'd'))
                        this.findTimeAfterFreeze($scope.plantId);
                    if (this.max && this.max > p.maxDate || !this.max) {
                        //this.max = <moment.Moment>p.maxDate;
                        this.max = typeof p.maxDate === 'string' ? moment.tz(p.maxDate, this.TZ) : p.maxDate;
                    }

                    if (this.min && this.min < p.minDate || !this.min) {
                        this.min = typeof p.minDate === 'string' ? moment.tz(p.minDate, this.TZ) : p.minDate;
                    }
                });
                $scope.prebookingConfirmed = true;
                $scope.showAutocompleteBtn = false;
            };
            $scope.emptyLapses = () => {
                $scope.allLapses = [];
            }

        }

        protected notExpiringRules(rules: any) {
            if (rules == null) return false;
            const excl = <any>JSON.parse(rules);
            if ((<any[]>excl.d).every(a => !a[ExclusionRuleEnum.EndValidity]))
                return true;
            else
                return false;
        }

        public setOpenings(a: WorkingDay, alt?: moment.Moment) {
            //Set datepicker ng-model on step 1
            this.$scope.data.selecteddate = a.Opening.tz(this.TZ).format('YYYY/MM/DD');
            //Set datepicker minDate on step 1
            this.$scope.now = a.Opening.tz(this.TZ);
            this.$scope.selectedWD.Opening = this.$scope.minValidDate = (alt || a.Opening).tz(this.TZ).clone();
            this.$scope.selectedWD.Closing = a.Closing.clone();
            this.$scope.data.selectedtime = (alt || a.Opening).tz(this.TZ).clone().hours();
            this.$scope.$applyAsync();
        }

        //protected findTimeAfterFreeze(plantId: number) {
        //    const nowPlusFreeze = this.now().add(this.$scope.freezeBooking, 'h');
        //    let count = 0;
        //    let days = this.now().add(this.$scope.freezeBooking, 'h').startOf('d');
        //    console.log(days);
        //    if (this.$scope.todayWD.Opening && this.$scope.todayWD.Closing) {
        //        //if (this.now().isBefore(this.$scope.todayWD.Closing))
        //        if (nowPlusFreeze.isBefore(this.$scope.todayWD.Closing)) {
        //            this.setOpenings({
        //                Opening: moment.max([this.$scope.todayWD.Opening, this.now().add(this.$scope.freezeBooking, 'h')]),
        //                Closing: this.$scope.todayWD.Closing
        //            });
        //        } else {
        //            this.genericHelper.findNextWDs(plantId, this.MAXDAYS, this.now().add(1, 'd')).then(res => {
        //                // Sono dentro una opening
        //                let workDay = res.filter(wd =>
        //                    BookingBase.isDateAndOpenTime(nowPlusFreeze, wd));
        //                console.log("Workday:");
        //                console.log(workDay);
        //                if (workDay.length > 0)
        //                    this.setOpenings(workDay[0], workDay[0].Opening.clone().hours(nowPlusFreeze.hours()));
        //                else {
        //                    let nextWorkDay = res.filter(wd => wd.Opening.isAfter(nowPlusFreeze));
        //                    console.log("NextWorkDay:");
        //                    console.log(nextWorkDay);
        //                    if (nextWorkDay.length > 0)
        //                        this.setOpenings(nextWorkDay[0]);
        //                }
        //            });
        //        }
        //    } else {
        //        this.genericHelper.findNextWDs(plantId, 7, this.TZ).then(res => {
        //            let workDay = res.filter(wd =>
        //                BookingBase.isDateAndOpenTime(nowPlusFreeze, wd));
        //            console.log("Else Workday:");
        //            console.log(workDay);
        //            if (workDay.length > 0)
        //                this.setOpenings(workDay[0], workDay[0].Opening.clone().hours(nowPlusFreeze.hours()));
        //            else {
        //                let nextWorkDay = res.filter(wd => wd.Opening.isAfter(nowPlusFreeze));
        //                console.log("Else NextWorkDay:");
        //                console.log(nextWorkDay);
        //                if (nextWorkDay.length > 0)
        //                    this.setOpenings(nextWorkDay[0]);
        //            }
        //        });
        //    }
        //}

        protected async findTimeAfterFreeze(plantId: number) {
            const nowPlusFreeze = this.now().add(this.$scope.freezeBooking, 'h');
            //let count = 0;
            if (this.$scope.todayWD.Opening && this.$scope.todayWD.Closing) {
                //if (this.now().isBefore(this.$scope.todayWD.Closing))
                if (nowPlusFreeze.isBefore(this.$scope.todayWD.Closing)) {
                    this.setOpenings({
                        Opening: moment.max([this.$scope.todayWD.Opening, nowPlusFreeze]),
                        Closing: this.$scope.todayWD.Closing
                    });
                } else {
                    const res = await this.genericHelper.findNextWDs(plantId, this.MAXDAYS, this.now().add(1, 'd'));
                    // Sono dentro una opening
                    let workDay = res.filter(wd =>
                        BookingBase.isDateAndOpenTime(nowPlusFreeze, wd));
                    if (workDay.length > 0)
                        this.setOpenings(workDay[0], workDay[0].Opening.clone().hours(nowPlusFreeze.hours()));
                    else {
                        let nextWorkDay = res.filter(wd => wd.Opening.isAfter(nowPlusFreeze));
                        if (nextWorkDay.length > 0)
                            this.setOpenings(nextWorkDay[0]);
                    }
                }
            } else {
                const res = await this.genericHelper.findNextWDs(plantId, 7, this.TZ);
                let workDay = res.filter(wd =>
                    BookingBase.isDateAndOpenTime(nowPlusFreeze, wd));
                if (workDay.length > 0)
                    this.setOpenings(workDay[0], workDay[0].Opening.clone().hours(nowPlusFreeze.hours()));
                else {
                    let nextWorkDay = res.filter(wd => wd.Opening.isAfter(nowPlusFreeze));
                    if (nextWorkDay.length > 0)
                        this.setOpenings(nextWorkDay[0]);
                }
            }
        }

        private static getFromLocalStorage(element: string) {
            try { return localStorage.getItem(element) || '' } catch { return '' };
        }

        private static fillFieldFromLocalStorage(element: string) {
            try { return localStorage.getItem(element) || '' } catch { return '' };
        }

        private static saveFieldInLocalStorage(element: string, value?: string) {
            try { localStorage.setItem(element, value || ''); } catch { }
        }

        private static isDateAndOpenTime(date: moment.Moment, wd: WorkingDay) {
            return date.isBetween(wd.Opening, wd.Closing, 'minute', '[)');
        }

        private static isDateAndNotOpenTime(date: moment.Moment, wd: WorkingDay) {
            return date.isBetween(wd.Opening, wd.Closing, 'date', '[]') && !date.isBetween(wd.Opening, wd.Closing, 'minute', '[)');
        }

        private static isBeforeOpenTime(date: moment.Moment, wd: WorkingDay) {
            return date.isBetween(wd.Opening, wd.Closing, 'date', '[]') && date.isBefore(wd.Opening, 'minute');
        }

        private static isAfterOpenTime(date: moment.Moment, wd: WorkingDay) {
            return date.isBetween(wd.Opening, wd.Closing, 'date', '[]') && date.isAfter(wd.Closing, 'minute');
        }

        private static isNotDate(date: moment.Moment, wd: WorkingDay) {
            return !date.isBetween(wd.Opening, wd.Closing, 'date', '[]');
        }

        private static dateNotOpeningAndBeforeFirstOpening(date: moment.Moment, openings: WorkingDay[]) {
            return !openings.some(o => o.Opening.isSame(date, 'date')) && date.isBefore(openings[0].Opening);
        }
        private getField(field: keyof IBookingData) {
            if (this.$scope.data.hasOwnProperty(field)) {
                const a = this.$scope.data[field];
                if (angular.isString(a))
                    return a.toUpperCase();
            }
            return null;
        }
        private saveStep(step: number) {
            if (step == 2) {
                BookingBase.saveFieldInLocalStorage('email', this.$scope.data.email);
                BookingBase.saveFieldInLocalStorage('truckType', this.$scope.data.selectedTruckType);
            } else {
                BookingBase.saveFieldInLocalStorage('carrier', this.getField('carrier'));
                BookingBase.saveFieldInLocalStorage('external', this.getField('external'));
                BookingBase.saveFieldInLocalStorage('refname', this.getField('refname'));
                BookingBase.saveFieldInLocalStorage('refnum', this.getField('refnum'));
                BookingBase.saveFieldInLocalStorage('truckplate', this.getField('truckplate'));
                BookingBase.saveFieldInLocalStorage('trailerplate', this.getField('trailerplate'));
                BookingBase.saveFieldInLocalStorage('sender', this.getField('sender'));
                BookingBase.saveFieldInLocalStorage('phonenumber', this.getField('phonenumber'));
                BookingBase.saveFieldInLocalStorage('receiver', this.getField('receiver'));
                BookingBase.saveFieldInLocalStorage('notes', this.$scope.data.notes);
            }
        }
        protected selectLapse(lapse: ILapseAvailable) {
            for (let l of this.$scope.allLapses)
                l.Selected = false;
            lapse.Selected = true;
            return moment.tz(this.$scope.data.selecteddate, 'YYYY/MM/DD', this.TZ).isSame(lapse.From, 'd');
        }
        private static SortICodeNameOrder<T extends ICodeNameOrder>(a: T[]) {
            return a.sort((a, b) => a.Order - b.Order);
        }
        private static MapSortICodeNameOrder<T extends ICodeNameOrder>(a: T[]): ICodeNameOrder[] {
            return LM.BookingBase.SortICodeNameOrder(a.map(d => ({ Code: d.Code.trim(), Name: d.Name.trim(), Order: d.Order })));
        }

        protected TZ: string;

        protected GetD(plantId: number) {
            return this.$http.post<LM.IGetD>('/Booking/Book/GetD', { PlantId: plantId }).then(res => {
                this.$scope.productGroupsValues = LM.BookingBase.SortICodeNameOrder(res.data.productGroups.map(pg => ({ Code: pg.Code.trim(), Name: pg.Name.trim(), Value: 0, Order: pg.Order, Limit: pg.Limit })));
                this.$scope.truckTypes = LM.BookingBase.MapSortICodeNameOrder(res.data.trucks);
                this.$scope.destinations = LM.BookingBase.MapSortICodeNameOrder(res.data.destinations);
                this.$scope.tripTypes = LM.BookingBase.MapSortICodeNameOrder(res.data.tripTypes);
                this.$scope.customerCode = res.data.customerCode;
                this.$scope.selectedWD.Opening = this.$scope.todayWD.Opening = res.data.openingHour ? TargetToLocal(res.data.openingHour, res.data.Tz)/*moment.utc(res.data.openingHour)*/ : null;
                this.$scope.selectedWD.Closing = this.$scope.todayWD.Closing = res.data.closingHour ? TargetToLocal(res.data.closingHour, res.data.Tz)/*moment.utc(res.data.closingHour)*/ : null;
                this.$scope.docksLimit = res.data.maxDocks;
                this.$scope.freezeBooking = res.data.FreezeBooking;
                this.$scope.loadUnload = this.$scope.origLoadUnload = this.$scope.loadUnload.filter(i => res.data.workflowEnabled.some(a => LM.ActionType[a] == i.name));
                this.$scope.loadUnloadEnabled = res.data.workflowEnabled.indexOf(LM.ActionType.LoadUnload) >= 0;
                this.TZ = res.data.Tz;
                $('#localDestTime').text(moment.tz(res.data.Tz).format('YYYY/MM/DD HH:mm'));
                this.$scope.InvitationOnly = res.data.InvitationOnly;
            });
        }

        protected getCustomerPlant() {
            return this.$scope.docks.find(d => d.Id == this.$scope.hub_id);
        }

        protected async GetMultiplePreBook(plantId: number, prebookings: string, code: string): Promise<PrebookingMultiple[]> {
            const values = await this.$http.post<{
                Code: string,
                Pin: string,
                Json: string
            }[]>('/booking/api/prebook/MultiplePrebookCheck', {
                cust: plantId,
                prebookings: prebookings,
            });

            let res: PrebookingMultiple[] = [];
            for (let obj of values.data) {
                let q = JSON.parse(obj.Json);
                const date = moment.utc(q.booking.date);
                const datepart = date.isValid() ? {
                    selecteddate: date.format('YYYY/MM/DD'),
                    selectedtime: date.hours()
                } : {
                    selecteddate: null,
                    selectedtime: 0
                };

                let tmp: PrebookingMultiple = {
                    code: obj.Code,
                    pin: obj.Pin,
                    booking: {
                        ...datepart,
                        country: '',
                        email: q.booking?.email,
                        selectedTruckType: q.booking?.trucktype,
                        carrier: q.booking?.carrier,
                        refname: q.booking?.refname,
                        external: q.booking?.external,
                        refnum: code,
                        truckplate: q.booking?.truckplate,
                        trailerplate: q.booking?.trailerplate,
                        sender: q.booking?.sender,
                        phonenumber: q.booking?.phone,
                        receiver: q.booking?.receiver,
                        notes: q.booking?.note,
                        privacySelectedValue: '',
                        mindate: q.booking.mindate ? q.booking.mindate : null,
                        //maxdate: q.booking.maxdate ? MoveFromUTCToLocal(q.booking.maxdate, this.TZ) : null
                        maxdate: q.booking.maxdate ? q.booking.maxdate : null
                    },
                    products: q.products?.map((a: any) => ({
                        Code: a.code,
                        Value: a.value,
                        Type: a.type,
                        TripType: a.triptype,
                        Destination: a.destination
                    }))
                };

                res.push(tmp);
            }

            return res;
        }

        protected async GetPreBook(plantId: number, code: string, ship: string, pin: string): Promise<{ booking: IBookingData & { mindate: moment.Moment, maxdate: moment.Moment, freezingHours: number }, products: BookingProduct[] }> {
            //int cust, string plant, string shipref, string pin
            const q = await this.$http.post<{
                booking: {
                    email: string;
                    date: string | null;
                    trucktype: string;
                    carrier: string;
                    refname: string;
                    external: string;
                    truckplate: string;
                    trailerplate: string;
                    sender: string;
                    phone: string;
                    receiver: string;
                    note: string;
                    mindate: string;
                    maxdate: string;
                    freezingHours: number
                };
                products?: {
                    code: string;
                    value: number;
                    type: string;
                    triptype: string;
                    destination: string;
                }[];
            }>('/booking/api/prebook/post', {
                cust: plantId,
                plant: code,
                shipref: ship,
                pin: pin
            });
            const date = moment.utc(q.data.booking.date);
            const datepart = date.isValid() ? {
                selecteddate: date.format('YYYY/MM/DD'),
                selectedtime: date.hours()
            } : {
                selecteddate: null,
                selectedtime: 0
            };
            return {
                booking: {
                    ...datepart,
                    country: '',
                    email: q.data.booking?.email,
                    selectedTruckType: q.data.booking?.trucktype,
                    carrier: q.data.booking?.carrier,
                    refname: q.data.booking?.refname,
                    external: q.data.booking?.external,
                    refnum: code,
                    truckplate: q.data.booking?.truckplate,
                    trailerplate: q.data.booking?.trailerplate,
                    sender: q.data.booking?.sender,
                    phonenumber: q.data.booking?.phone,
                    receiver: q.data.booking?.receiver,
                    notes: q.data.booking?.note,
                    privacySelectedValue: '',
                    mindate: q.data.booking.mindate ? moment(q.data.booking.mindate) : null,
                    //maxdate: q.data.booking.maxdate ? MoveFromUTCToLocal(q.data.booking.maxdate, this.TZ) : null,
                    maxdate: q.data.booking.maxdate ? moment(q.data.booking.maxdate) : null,
                    freezingHours: q.data.booking.freezingHours
                },
                products: q.data.products?.map(a => ({
                    Code: a.code,
                    Value: a.value,
                    Type: a.type,
                    TripType: a.triptype,
                    Destination: a.destination
                }))
            };
        }

        private compareFields(field: string, newValue: string) {
            if (!field && newValue != null && newValue != 'undefined')
                field = newValue?.toUpperCase();
            else if (newValue != null && newValue != 'undefined' && field?.toUpperCase().trim().indexOf(newValue?.toUpperCase().trim()) < 0)
                field = ` - ${newValue.toUpperCase()}`;
            else
                field = '';
            return field;
        }

        //private omit = <T extends {}, K extends Omit<T, string>>(
        //    obj: T, ...keys: string[]
        //) => (
        //    Object.fromEntries(
        //        Object.entries(obj)
        //            .filter(([key]) => !keys.includes(key))
        //    ) as K
        //)
    }

    globalApp.directive('autoSelect', () => ({
        restrict: 'A',
        require: 'uiSelect',
        link: function ($scope, _1, _2, $select: any) {
            angular.element(function () { // Evaluated when DOM is ready
                $scope.$evalAsync(function () { // Execute its callback within the current digest cycle if one is occurring.
                    // Otherwise a new digest cycle will start executing the callback.
                    if ($select.items.length === 1) {
                        $select.selected = $select.items[0];
                    }
                });
            });
        }
    }));
    globalApp
        .filter('formattz', () => (a: moment.Moment, tz: string) => moment.tz(a, tz).format('YYYY/MM/DD HH:mm'))
        .filter('showName', () => (code: string, values: { Code: string, Name: string }[]) => values.find((val) => val.Code == code).Name);

}
